/**
 * The shared drawing and pulse behind the dot glyphs: a single circle at the
 * exact center of the grid, used as a status marker beside other content.
 *
 * Progress swells the dot to PEAK_SCALE at the half-way point and settles it
 * back, so rest (0) and a whole cycle (1) draw the same dot. It scales about
 * the canvas center, so the dot stays centered at every point of the cycle and
 * the swell never leaves the 24 box.
 *
 * Color slot: 0 the dot.
 */import{TAU,wrapProgress}from"web/shared/icons/progress";export const DOT_CENTER=12;// Small enough to read as a marker rather than a blob, large enough to survive
// the small sizes where a status dot usually lives. At the peak of the pulse
// this reaches 8.25, so the dot stays well inside the 24 box.
const DOT_RADIUS=5.5;// How large the dot grows at the peak of the pulse.
const PEAK_SCALE=1.5;// The dot's radius at a point in the cycle.
export function pulsedRadius(progress){const wrapped=wrapProgress(progress);// One smooth out-and-back: rest, peak at the half-way point, rest again.
const pulse=(1-Math.cos(TAU*wrapped))/2;return DOT_RADIUS*(1+(PEAK_SCALE-1)*pulse);}